function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { MediaTailorErrorCodes } from './ad-breaks-provider.enums';
import { CvsdkError, ErrorSeverity } from '../../../error';
export { MediaTailorErrorCodes } from './ad-breaks-provider.enums';
var MIN_DATA_UPDATE_INTERVAL = 4000;
var noop = function(reason) {};
export var MediaTailorRequestManager = /*#__PURE__*/ function() {
    "use strict";
    function MediaTailorRequestManager(options) {
        _class_call_check(this, MediaTailorRequestManager);
        _define_property(this, "options", void 0);
        _define_property(this, "lastUpdateStartTime", void 0);
        _define_property(this, "requestInQueue", void 0);
        _define_property(this, "nextToken", void 0);
        _define_property(this, "rejectRequestInProgress", void 0);
        this.options = options;
        this.lastUpdateStartTime = -Infinity;
        this.requestInQueue = false;
        this.nextToken = null;
        this.rejectRequestInProgress = noop;
    }
    _create_class(MediaTailorRequestManager, [
        {
            key: "requestDataUpdate",
            value: function requestDataUpdate() {
                var _this = this;
                return _async_to_generator(function() {
                    var timeSinceLastUpdate, timeUntilUpdateAllowed;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                timeSinceLastUpdate = Date.now() - _this.lastUpdateStartTime;
                                if (!(timeSinceLastUpdate < MIN_DATA_UPDATE_INTERVAL)) return [
                                    3,
                                    2
                                ];
                                if (_this.requestInQueue) {
                                    throw CvsdkError.from({
                                        code: MediaTailorErrorCodes.INTERVAL_EXCEEDED,
                                        message: 'No request made as insufficient time has passed since the last request',
                                        severity: ErrorSeverity.Warning
                                    });
                                }
                                _this.requestInQueue = true;
                                timeUntilUpdateAllowed = Math.max(MIN_DATA_UPDATE_INTERVAL - timeSinceLastUpdate, 0);
                                return [
                                    4,
                                    new Promise(function(r) {
                                        return setTimeout(r, timeUntilUpdateAllowed);
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _this.requestInQueue = false;
                                _state.label = 2;
                            case 2:
                                _this.lastUpdateStartTime = Date.now();
                                _this.rejectRequestInProgressWithTimeout();
                                return [
                                    2,
                                    Promise.race([
                                        _this.fetchTrackingUrl(),
                                        new Promise(function(_, reject) {
                                            // TODO actually abort request in progress rather than ignoring result
                                            _this.rejectRequestInProgress = reject;
                                        })
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.rejectRequestInProgress(CvsdkError.from({
                    code: MediaTailorErrorCodes.DESTROYED,
                    message: 'Media tailor destroyed while request in progress',
                    severity: ErrorSeverity.Warning
                }));
            }
        },
        {
            key: "rejectRequestInProgressWithTimeout",
            value: function rejectRequestInProgressWithTimeout() {
                // note rejection will not take effect if the last request resolved
                this.rejectRequestInProgress(CvsdkError.from({
                    code: MediaTailorErrorCodes.TIMEOUT,
                    message: 'Ads data request timed out',
                    severity: ErrorSeverity.Warning
                }));
            }
        },
        {
            key: "fetchTrackingUrl",
            value: function fetchTrackingUrl() {
                var _this = this;
                return _async_to_generator(function() {
                    var response, e, parsedBody, e1;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    fetch(_this.constructTrackingUrl())
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                throw CvsdkError.from({
                                    code: MediaTailorErrorCodes.NETWORK_ERROR,
                                    message: 'Network error fetching ads data',
                                    severity: ErrorSeverity.Warning
                                });
                            case 3:
                                if (200 < response.status || response.status >= 300) {
                                    throw CvsdkError.from({
                                        code: MediaTailorErrorCodes.BAD_HTTP_RESPONSE_CODE,
                                        message: 'Bad HTTP response code from server for ads data',
                                        severity: ErrorSeverity.Warning
                                    });
                                }
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    response.json()
                                ];
                            case 5:
                                parsedBody = _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e1 = _state.sent();
                                throw CvsdkError.from({
                                    code: MediaTailorErrorCodes.PARSE_ERROR,
                                    message: 'Unable to parse ads data response',
                                    severity: ErrorSeverity.Warning,
                                    cause: e1
                                });
                            case 7:
                                if (_this.options.paginationEnabled) {
                                    _this.nextToken = parsedBody.nextToken;
                                }
                                return [
                                    2,
                                    parsedBody
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "constructTrackingUrl",
            value: function constructTrackingUrl() {
                return this.options.paginationEnabled && this.nextToken ? "".concat(this.options.trackingUrl, "?aws.nextToken=").concat(this.nextToken) : this.options.trackingUrl;
            }
        }
    ]);
    return MediaTailorRequestManager;
}();

//# sourceMappingURL=media-tailor-request-manager.js.map